import * as React from 'react';

import type {CoreEntityType} from 'nutshell-core/types';

// @ts-expect-error
import InputAjaxSearch from '../../base/input-ajax-search';
// @ts-expect-error
import getClassesMixin from '../../mixins/get-classes';

import {SearchResultsEmptyView} from './empty-view';
import {SearchHeader} from './search-header';
import {SearchResultItem} from './search-result-item';

type Props = {
    placeholder?: string;
    focusOnMount?: boolean;
    updateQueryOnSelect?: boolean;
    onSelect: (arg1?: any | null | undefined) => any;
    types?: CoreEntityType[];
    hierarchyTypeFilter?: string;
};

export class EntitySearch extends React.Component<Props> {
    getClasses = getClassesMixin;

    render() {
        const classes = this.getClasses('ui-entity-search');

        return (
            <div className={classes}>
                <InputAjaxSearch
                    placeholder={this.props.placeholder}
                    popoverClass='entity'
                    header={SearchHeader}
                    emptyView={SearchResultsEmptyView}
                    focusOnMount={this.props.focusOnMount}
                    updateQueryOnSelect={this.props.updateQueryOnSelect}
                    onSelect={this.handleSelect}
                    // @ts-expect-error
                    renderRow={(result, highlighted) =>
                        this.renderSearchResultRow(result, highlighted)
                    }
                    // @ts-expect-error
                    search={(q, callback) => this.search(q, callback)}
                />
            </div>
        );
    }

    search(queryString: string, callback: (arg1: any[]) => any) {
        const resultsCollection = new Nut.Model.SearchResultsCollection({
            q: queryString,
            entityTypes: this.props.types,
            hierarchyType: this.props.hierarchyTypeFilter,
        });

        resultsCollection.fetch().done(() => callback(resultsCollection.models));
    }

    renderSearchResultRow(result: any, isHighlighted: boolean) {
        return (
            <SearchResultItem key={result.id} searchResult={result} isSelected={isHighlighted} />
        );
    }

    handleSelect = (e: Event, result: any) => {
        e.preventDefault();
        this.props.onSelect(result);
    };
}
